import "./wallet.scss";
const WalletLayout = ({ children }) => {
  return <div className="container-main container-wa">{children}</div>;
};

export default WalletLayout;
